<div class="header-navigation">
  @if (currentEvent | async; as event) {
    @if (event?.isLineupPublic) {
      <div
      class="header-navigation-item"
      routerLink="/lineup/list"
      routerLinkActive="route-active">LINE UP</div>
    }
  }
  <!-- <div
  class="header-navigation-item"
  routerLink="/instalations"
  routerLinkActive="route-active">INSTALLATIONS</div> -->
  @if (currentEvent | async; as event) {
    @if (event?.isSchedulePublic) {
      <div
      class="header-navigation-item"
      routerLink="/schedule/all"
      routerLinkActive="route-active">SCHEDULE</div>
    }
  }
  <div
    class="header-navigation-item"
    routerLink="/history/list"
    routerLinkActive="route-active"
  >
    HISTORY
  </div>
  <div
    class="header-navigation-item"
    routerLink="/info"
    routerLinkActive="route-active"
  >
    INFO
  </div>
  <!-- @if (user | async; as userData) {
    @if (userData?.status === 'industry') {
      <div
        class="header-navigation-item"
        routerLink="/profile/invites"
        routerLinkActive="route-active"
      >
        INVITES
      </div>
      <div
        class="header-navigation-item"
        routerLink="/profile/industry-meetups"
        routerLinkActive="route-active"
      >
        INDUSTRY MEETUPS
      </div>
    }
  } -->
  <!-- <div
    class="header-navigation-item"
    routerLink="/opencall"
    routerLinkActive="route-active"
  >
    OPEN CALL
  </div> -->
</div>
